import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=6fda14d5&"
import script from "./checkout.vue?vue&type=script&lang=ts&"
export * from "./checkout.vue?vue&type=script&lang=ts&"
import style0 from "./checkout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./checkout.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports